var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWifiinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "m66 18.828-34 34-34-34C16.778.051 47.222.051 66 18.828"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 55,
  r: 18,
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 55,
  r: 30,
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 55,
  r: 42,
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 32,
  cy: 53,
  fill: "currentColor",
  mask: "url(#b)",
  rx: 4.923,
  ry: 4.6
}))));
export default SvgWifiinline;